import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Pill/PillUsage.mdx";

import Examples from "../../Docs/Components/Pill/PillExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Pill"
            description="Pill is a flexible component that can be used to display interactive and non-interactive information within a variety of contexts."
            apiSources={["azure-devops-ui/Components/Pill/Pill.Props.d.ts", "azure-devops-ui/Components/PillGroup/PillGroup.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"done"}}
            usage={Usage}
        />
    );
}
}
        
export default Page;